import { useEffect, useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';
import { filtrarCategorias } from './fichaAtributos';

/* =====================================================================
   SELECTOR DE CATEGORÍA CON RUTA · CATÁLOGO VIVO F2.1
   =====================================================================
   Un buscador sobre el árbol: «resis» encuentra «Componente electrónico >
   Resistencia» y la muestra con su ruta completa, para no confundir dos
   ramas. Sin texto, el árbol entero en orden.

   Uso: <SelectorCategoria id="cv-categoria" valor={idCat} onElegir={setIdCat} />
   ===================================================================== */
export default function SelectorCategoria({ id = 'cv-categoria', etiqueta = 'Categoría', valor, onElegir }) {
  const [categorias, setCategorias] = useState(null);
  const [texto, setTexto] = useState('');
  const [error, setError] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get('/catalogo-vivo/catalogo/categorias')
      .then((r) => { if (vivo) setCategorias(r.categorias || []); })
      .catch(() => { if (vivo) setError('No se pudieron leer las categorías. Revisa la conexión y vuelve a abrir la ficha.'); });
    return () => { vivo = false; };
  }, []);
  const elegida = categorias?.find((c) => c.id === valor) || null;
  const visibles = useMemo(() => filtrarCategorias(categorias, texto).slice(0, 30), [categorias, texto]);

  return (
    <div className="space-y-1" data-catalogo-vivo="selector-categoria">
      <label htmlFor={id} className="block text-sm font-semibold text-gray-700">{etiqueta}</label>
      <p className="text-sm text-gray-800 break-words" data-categoria-elegida>
        {elegida ? elegida.ruta_texto : 'Sin categoría'}
      </p>
      <div className="relative">
        <Search className="h-4 w-4 text-gray-500 absolute left-3 top-4" aria-hidden="true" />
        <input id={id} type="search" value={texto} onChange={(e) => setTexto(e.target.value)} autoComplete="off"
          placeholder="Busca: resistencia, libro…" className="w-full min-h-12 rounded-xl border border-gray-300 pl-9 pr-3 text-base" />
      </div>
      <Ayuda id="catalogo_vivo.ficha.categoria" />
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      {texto && categorias && (
        <ul className="space-y-1 max-h-72 overflow-y-auto">
          {visibles.length === 0 && <li className="text-sm text-gray-600 p-2">Ninguna categoría se llama así. Créala en Administración → Catálogo.</li>}
          {visibles.map((c) => (
            <li key={c.id}>
              <button type="button" data-elegir-categoria={c.id}
                onClick={() => { onElegir(c.id, c); setTexto(''); }}
                className="w-full min-h-11 rounded-lg border border-gray-100 px-3 text-left text-sm break-words">
                {c.ruta_texto}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
